
import { useEffect } from 'react';
import Hero from './components/Hero';
import WhatIsFunding from './components/WhatIsFunding';
import Benefits from './components/Benefits';
import ForWhom from './components/ForWhom';
import Process from './components/Process';
import Trust from './components/Trust';
import FAQ from './components/FAQ';
import FinalCTA from './components/FinalCTA';

export default function FundingPage() {
  useEffect(() => {
    // Schema.org JSON-LD para la página de Funding
    const schemas = [
      {
        '@context': 'https://schema.org',
        '@type': 'Organization',
        name: 'Cashflow VIP',
        url: import.meta.env.VITE_SITE_URL || 'https://example.com',
        logo: 'https://static.readdy.ai/image/79a7f2b53ad81669f992c9be02ef39d3/22016f785dd23e44468347a3990bbdbc.png',
        description: 'Expertos en crédito y funding empresarial. Accede a capital estratégico con 0% de interés promocional para impulsar tu negocio.',
        founder: [
          {
            '@type': 'Person',
            name: 'Ariel',
            jobTitle: 'Experto en Crédito y Fundador'
          },
          {
            '@type': 'Person',
            name: 'Fior',
            jobTitle: 'Experto en Crédito y Fundador'
          }
        ]
      },
      {
        '@context': 'https://schema.org',
        '@type': 'Service',
        name: 'Servicio de Funding Empresarial',
        description: 'Accede a capital estratégico con 0% de interés promocional. Tarjetas personales y de negocio, líneas de crédito y productos bancarios para emprendedores.',
        provider: {
          '@type': 'Organization',
          name: 'Cashflow VIP',
          url: import.meta.env.VITE_SITE_URL || 'https://example.com'
        },
        areaServed: 'US',
        serviceType: 'Funding Empresarial',
        offers: {
          '@type': 'Offer',
          description: 'Capital con 0% de interés promocional',
          availability: 'https://schema.org/InStock'
        }
      },
      {
        '@context': 'https://schema.org',
        '@type': 'FAQPage',
        mainEntity: [
          {
            '@type': 'Question',
            name: '¿Qué es el Funding?',
            acceptedAnswer: {
              '@type': 'Answer',
              text: 'El Funding es una estrategia financiera que te permite acceder a capital mediante tarjetas de crédito personales y de negocio, líneas de crédito y otros productos bancarios, aprovechando períodos promocionales de 0% de interés.'
            }
          },
          {
            '@type': 'Question',
            name: '¿Cómo funciona el proceso?',
            acceptedAnswer: {
              '@type': 'Answer',
              text: 'El proceso incluye: 1) Consulta inicial gratuita, 2) Análisis de tu perfil crediticio, 3) Estrategia personalizada, 4) Aplicación a productos financieros, 5) Aprobación y acceso al capital.'
            }
          },
          {
            '@type': 'Question',
            name: '¿Para quién es este servicio?',
            acceptedAnswer: {
              '@type': 'Answer',
              text: 'Este servicio es ideal para emprendedores que necesitan capital inicial, dueños de negocio que buscan expandirse, inversionistas en bienes raíces, y personas que desean optimizar su crédito.'
            }
          }
        ]
      },
      {
        '@context': 'https://schema.org',
        '@type': 'WebPage',
        name: 'Funding Cashflow VIP - Capital con 0% Interés Promocional',
        description: 'Accede a capital estratégico con 0% de interés promocional para impulsar tu negocio o inversiones.',
        url: import.meta.env.VITE_SITE_URL || 'https://example.com'
      }
    ];

    const scriptIds = schemas.map((schema, index) => {
      const script = document.createElement('script');
      script.type = 'application/ld+json';
      script.id = `schema-funding-${index}`;
      script.textContent = JSON.stringify(schema);
      document.head.appendChild(script);
      return script.id;
    });

    return () => {
      scriptIds.forEach(id => {
        const script = document.getElementById(id);
        if (script) {
          document.head.removeChild(script);
        }
      });
    };
  }, []);

  return (
    <div className="bg-[#050505] min-h-screen">
      <Hero />
      <WhatIsFunding />
      <Benefits />
      <ForWhom />
      <Process />
      <Trust />
      <FAQ />
      <FinalCTA />
    </div>
  );
}
